import getConfig from 'next/config';

import * as actions from '@actions/filters';

import * as endpoints from '@common/endpoints';

const { PRODUCTS_BACKEND_URL } = getConfig().publicRuntimeConfig;

export const fetchFiltersOptions =
  (filters = {}, options = {}) =>
  (dispatch, _, request) => {
    dispatch(actions.fetchFiltersOptionsRequest(filters));

    return request
      .get(endpoints.filters(), {
        baseURL: PRODUCTS_BACKEND_URL,
        params: {
          ...filters,
        },
      })
      .then(({ data }) => {
        if (options.isInitial) {
          dispatch(actions.setInitialFilterOptions(filters, data));
        }

        switch (options.setPartial) {
          case 'sizes':
            dispatch(actions.setFilterSizes(data.sizeFilters));
            break;
          case 'colors':
            dispatch(actions.setFilterColors(data.colorFilters));
            break;
          default:
            dispatch(actions.fetchFiltersOptionsSuccess(filters, data));
        }
      })
      .catch(error => {
        if (options.isInitial) {
          dispatch(actions.setInitialFilterOptions(filters));
        }
        dispatch(actions.fetchFiltersOptionsFailure(filters, error));
      });
  };
